﻿import { SetStateAction } from "react";
import Api from "../../Api";
import { IComboBoxOption, IMaterialDescriptionComboBoxOption, IMaterialSiteComboBoxOption } from "../../interfaces";

export const Values = {

    setValues: (valueName: string, setFunction: SetStateAction<any>) => {
        return Api.Values.get(valueName).then(async (data) => {

            var items: IMaterialDescriptionComboBoxOption[] | IMaterialSiteComboBoxOption[] | IComboBoxOption[] = (data as any[]).map((x) => {

                let item: any = {
                    id: x.id,
                    value: x.value
                }

                if (x.l2Descriptions) {
                    (item as IMaterialDescriptionComboBoxOption).getL2Descriptions = x.l2Descriptions
                    return item;
                }

                if (x.warehouses) {
                    (item as IMaterialSiteComboBoxOption).getWarehouses = x.warehouses
                    return item;
                }

                return item as IComboBoxOption
            });

            setFunction(items);
        })

    },

    isStrategicSpareType: (value: string | null | undefined) => {

        if (value) {
            if (["STRATEGIC", "TOOLING"].includes(value.toUpperCase()))
                return true;
        }
        return false;

    }
};

